<section class="a_denied">
  <!-- Image -->
  <img class="ad_icon" src="assets/images/access-denied.svg" />

  <!-- Title -->
  <h3 class="sub_title_2 fw_700 text_dark_blue lh_36 mb-2">Access Denied</h3>

  <!-- Caption -->
  <p class="lh_22 mb-4 text_center text_grey">
    Sorry. but you don’t have a permission
    <br />
    to access this page.
  </p>

  <!-- Back To Home -->
  <a href="" class="btn btn_primary" routerLink="/">Back to Home</a>
</section>
